import { Caption } from "@design-system/shadcn";
import React from "react";

import {
  type FieldValidationError,
  useFieldContext,
} from "../core/form-contexts";
import { getFieldErrorId } from "../core/get-field-error-id";

type FormFieldCaptionProps = Omit<
  React.ComponentProps<typeof Caption>,
  "children" | "id"
> & {
  children?: React.ReactNode;
};

function FormFieldCaption(props: FormFieldCaptionProps) {
  const field = useFieldContext<string>();

  if (!field) {
    throw new Error("FormFieldCaption must be used within form.AppField");
  }

  const errors = field.state.meta.errors as FieldValidationError[];

  if (errors.length === 0) {
    return null;
  }

  return (
    <Caption status="error" {...props} id={getFieldErrorId(field.name)}>
      {errors.map((error) => error.message).join(", ")}
    </Caption>
  );
}

export { FormFieldCaption };
export type { FormFieldCaptionProps };
